import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BadgeCheckIcon, XIcon } from "lucide-react";
import { buyers } from "../data/landing";
import { MOCKUP_URL } from "../data/offer";
export function PurchasePopup() {
  const [index, setIndex] = useState(() => Math.floor(Math.random() * buyers.length));
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timer = 0;
    const show = () => {
      setIndex(i => (i + 1) % buyers.length);
      setOpen(true);
      timer = window.setTimeout(hide, 5000);
    };
    const hide = () => {
      setOpen(false);
      timer = window.setTimeout(show, 9000);
    };
    timer = window.setTimeout(show, 6000);
    return () => window.clearTimeout(timer);
  }, [dismissed]);
  const buyer = buyers[index];
  return <div className="pointer-events-none fixed bottom-[92px] left-3 right-3 z-50 flex md:bottom-6 md:left-6 md:right-auto" aria-live="polite" data-id="element-39" data-mp="1gzgqgkn0he56">
      <AnimatePresence data-id="element-40" data-mp="16462ufgs8780">
        {open && !dismissed && <motion.div key={buyer.name} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-full max-w-[340px] items-center gap-3 rounded-2xl bg-white p-2.5 pr-9 shadow-[0_12px_32px_rgba(15,37,87,0.22)] ring-1 ring-navy/10" data-id="element-41" data-mp="117o17ogr0ozw">
            <img src={MOCKUP_URL} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-sky-soft object-cover" data-id="element-42" data-mp="x5u944kmctbc" />
            <div className="min-w-0" data-id="element-43" data-mp="s56hbgokg8g2">
              <p className="text-sm font-extrabold leading-snug text-ink" data-id="element-44" data-mp="s8atb089w8ha">
                {buyer.name} from {buyer.country}
              </p>
              <p className="text-[13px] leading-snug text-ink/75" data-id="element-45" data-mp="23lwi2ka8082a">just purchased this digital book</p>
              <p className="mt-0.5 flex items-center gap-1 text-[11px] font-bold text-mint" data-id="element-46" data-mp="2ap30h91dqoan">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-47" data-mp="2fn4taloly1zb" />
                {buyer.minutes} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-ink/50 transition-colors duration-150 hover:bg-navy/5 hover:text-ink" aria-label="Dismiss notification" data-id="element-48" data-mp="2kniq17krdpi1">
              <XIcon className="h-4 w-4" data-id="element-49" data-mp="1wxg130c54znn" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}